function loadAutocomplete() {
  const autocomplete = new google.maps.places.Autocomplete(document.getElementById('location_search'), {
    fields: ['geometry.viewport', 'name'],
    componentRestrictions: {country: 'fr'}
  });

  window.map.on('moveend', () => {
    const bounds = window.map.getBounds()

    const autocompleteBounds = {
      north: bounds._northEast.lat,
      south: bounds._southWest.lat,
      east: bounds._northEast.lng,
      west: bounds._southWest.lng
    }
    autocomplete.setOptions({bounds: autocompleteBounds})
  })

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace()

    window.gtag('event', 'search', {
      'event_label': place.name,
      'event_category': 'engagement',
    });
    window.fbq('track', 'Search');

    const viewport = place.geometry.viewport

    window.map.fitBounds([
      [viewport.getSouthWest().lat(), viewport.getSouthWest().lng()],
      [viewport.getNorthEast().lat(), viewport.getNorthEast().lng()]
    ])
  })
}

export default loadAutocomplete



